// Module
var code = "<svg width=\"10\" height=\"10\" viewBox=\"0 0 10 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 3.75L1.25 0L0 1.25L3.75 5L0 8.75L1.25 10L5 6.25L8.75 10L10 8.75L6.25 5L10 1.25L8.75 0L5 3.75Z\" fill=\"#F6F6F6\"/> </svg> ";
// Exports
module.exports = code;